import {
  FETCH_SINGLE_PAGE_START,
  FETCH_SINGLE_PAGE_SUCCESS,
  FETCH_SINGLE_PAGE_FAILURE,
  FETCH_SITE_WORKING_CONTENT_START,
  FETCH_SITE_WORKING_CONTENT_SUCCESS,
  FETCH_SITE_WORKING_CONTENT_FAILURE,
} from "./ActionConstant";

export function fetchSinglePageStart(data) {
  return {
    type: FETCH_SINGLE_PAGE_START,
    data,
  };
}

export function fetchSinglePageSuccess(data) {
  return {
    type: FETCH_SINGLE_PAGE_SUCCESS,
    data,
  };
}

export function fetchSinglePageFailure(error) {
  return {
    type: FETCH_SINGLE_PAGE_FAILURE,
    error,
  };
}

export function fetchHowItWorksContentStart(data) {
  return {
    type: FETCH_SITE_WORKING_CONTENT_START,
    data,
  };
}

export function fetchHowItWorksContentSuccess(data) {
  return {
    type: FETCH_SITE_WORKING_CONTENT_SUCCESS,
    data,
  };
}

export function fetchHowItWorksContentFailure(error) {
  return {
    type: FETCH_SITE_WORKING_CONTENT_FAILURE,
    error,
  };
}
